import { ClaimStatusTypes } from '../../models/ClaimStatus.model'
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export class AcceptClaimPageService {
  public async acceptClaimPage(pageId: number, isAgency: boolean): Promise<void> {
    const api = new ScrubstrApiQueryService()

    await api.post({
      endpoint: `admin/accept-claimed-page/${pageId}`,
      data: {
        isAgency,
      },
    })
  }
}
